import React from 'react'

export default function SplitRow ({ children, className = '' }) {
  return (
    <div className={'flex items-center space-x-4 md:space-x-8 ' + className}>
      {children}
    </div>
  )
}
